import { CellphoneKeyIcon } from './CellphoneKeyIcon';

/**
 * author: GreenTurtwig
 * id 29BA2DA3-CED6-4D52-92EF-D9152F63B7AB
 * name cellphone-key
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-key.svg
 * tags
 * - Cellphone / Phone 
 * - Device / Tech 
 */
export const SmartphoneKeyIcon = CellphoneKeyIcon;
export default SmartphoneKeyIcon